import { useCallback, useMemo, useRef } from "react";
import debounce from 'lodash/debounce';
import { useSelector } from "react-redux";
import { Input } from "../../../../components/ui/input";
import SelectListInput from "../../../../components/SelectListInput";

const StackViewEntry = ({
    index,
    columns,
    dataTypes,
    source,
    sourceType,
    destination,
    destType,
    addColumns = false,
    setType = () => {},
    changeMappedField = () => {},
    errors
  }) => {
    const { activeTab, uploadData } = useSelector((state) => state.Uploads);
  
    const destinationValue = useMemo(() => {
      return destination && destType 
        ? addColumns 
          ? destination 
          : `${destination} (${destType})` 
        : '';
    }, [destination, destType, addColumns]);
  
    const debouncedChangeMappedField = useRef(
      debounce((index, value) => {
        changeMappedField(index, value);
      }, 300)
    ).current;
  
    const handleInputChange = useCallback((e) => {
      debouncedChangeMappedField(index, e.target.value);
    }, [index, debouncedChangeMappedField]);
  
    return (
      <div className={`grid grid-cols-1 gap-1 pb-4 border-b`}>
        <div>
            <p>Source</p>
            <Input defaultValue={`${source} (${sourceType})`} className="w-full bg-white !opacity-100" disabled={true} />
        </div>
        <div>
          {addColumns ? (
            <div>
                <p>Destination (DB Field)</p>
                <div>
                    <Input
                        defaultValue={destinationValue}
                        className="w-full bg-white !opacity-100"
                        error={errors?.destination || ""}
                        onChange={handleInputChange}
                        disabled={uploadData.pending}
                    />
                    {errors?.destination && (
                        <small className="text-destructive text-xs mt-1">{errors?.destination}</small>
                    )}
                </div>
            </div>
          ) : (
            <div>
                <p>Destination (DB Field)</p>
                <SelectListInput
                  type="map"
                  list={columns}
                  onChange={(value) => changeMappedField(index, value)}
                  selectedValue={destinationValue}
                  placeholder=""
                  className="bg-white !opacity-100"
                  error={errors?.destination || ""}
                  disabled={activeTab === "additional_fields"}
                  clearable={true}
                />
            </div>
          )}
        </div>
        {addColumns && (
          <div>
            <p>Destination Data Type</p>
            {uploadData.pending ? (
              <Input defaultValue={`${destType}`} className="w-full bg-white !opacity-100" disabled={true} />
            ) : (
                <>
                <SelectListInput
                    type="list"
                    list={dataTypes}
                    onChange={(value) => {
                    if (value) setType(index, value);
                    }}
                    selectedValue={destType || null}
                    placeholder=""
                    className="bg-white !opacity-100"
                    error={errors?.destType || ""}
                    disabled={activeTab === "mapped_fields"}
                />
                </>
            )}
            {errors?.destType && (
              <small className="text-destructive text-xs mt-1">{errors?.destType}</small>
            )}
          </div>
        )}
      </div>
    );
  };
  
  export default StackViewEntry;
  